module.exports = __webpack_public_path__ + "img/yqxx.07951c07.png";